import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=5807edeb&scoped=true&functional=true&"
import script from "./ImageUpload.vue?vue&type=script&lang=ts&"
export * from "./ImageUpload.vue?vue&type=script&lang=ts&"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=5807edeb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5807edeb",
  null
  
)

export default component.exports